import './PaymentMethodPromo.less';
import { Icon, List } from 'antd';
import React, { useMemo } from 'react';

const details: Record<string, { title: string; icon?: string; content: string; image?: string; legal?: string }[]> = {
    credit_card: [
        {
            title: '100% SSL Secured Transaction with Stripe',
            icon: 'safety-certificate',
            content:
                "Stripe's payment infrastructure guarantees a no-hassle, smooth & most important, a totally secured transaction. Stripe is certified to PCI Service Provider Level 1, the most stringent level of certification.",
        },
        {
            title: 'Recurrent Payment - automated transactions',
            icon: 'dollar-circle',
            content:
                "There's no need to update your credit card every month to make a payment in order to keep your subscription. An automated payment system is included, that will notify you by e-mail each time the payment has been made.",
        },
        {
            title: 'You can cancel your subscription at any time',
            icon: 'close-circle',
            content:
                "If you want to stop your plan subscription you can do it at any given time. The recurrent payment will be stopped, but you won't be able to use our tools and features.",
        },
        {
            title: 'Refund policy',
            icon: 'backward',
            content:
                'We have a 24-hour refund policy for monthly subscriptions and a 7-day for yearly subscriptions. Only requests in this time-frame will be evaluated for refunding.',
        },
        {
            title: 'NVIDIA Inception program member',
            content: '',
            image: '/images/nvidia-inception-badge.svg',
            legal: `© ${new Date().getFullYear()} NVIDIA, the NVIDIA logo, and NVIDIA Inception are trademarks and/or registered trademarks of NVIDIA Corporation in the U.S. and other countries.`,
        },
    ],
    paypal: [
        {
            title: '100% SSL Secured Transaction with PayPal',
            icon: 'safety-certificate',
            content:
                "PayPal's payment infrastructure guarantees a no-hassle, smooth & most important, a totally secured transaction. PayPal is certified to PCI Service Provider Level 1, the most stringent level of certification.",
        },
        {
            title: 'Recurrent Payment - automated transactions',
            icon: 'dollar-circle',
            content:
                "There's no need to make a payment every year in order to keep your subscription. An automated payment system is included, that will notify you by e-mail each time the payment has been made.",
        },
        {
            title: 'You can cancel your subscription at any time',
            icon: 'close-circle',
            content:
                "If you want to stop your plan subscription you can do it at any given time. The recurrent payment will be stopped, but you won't be able to use our tools and features.",
        },
        {
            title: 'Refund policy',
            icon: 'backward',
            content:
                'We have a 24-hour refund policy for monthly subscriptions and a 7-day for yearly subscriptions. Only requests in this time-frame will be evaluated for refunding.',
        },
        {
            title: 'NVIDIA Inception program member',
            content: '',
            image: '/images/nvidia-inception-badge.svg',
            legal: `© ${new Date().getFullYear()} NVIDIA, the NVIDIA logo, and NVIDIA Inception are trademarks and/or registered trademarks of NVIDIA Corporation in the U.S. and other countries.`,
        },
    ],
};

type Props = {
    paymentMethod: string;
    includeRefundDetails?: boolean;
};

export default function PaymentMethodPromo({ paymentMethod, includeRefundDetails }: Props) {
    const filteredDetails = useMemo(
        () => (includeRefundDetails ? details[paymentMethod] : details[paymentMethod].filter((item) => item.title !== 'Refund policy')),
        [includeRefundDetails, paymentMethod]
    );

    return (
        <List
            className="payment-method-promo"
            itemLayout="vertical"
            size="small"
            bordered
            dataSource={filteredDetails}
            renderItem={(item) => (
                <List.Item key={item.title}>
                    <List.Item.Meta
                        title={
                            <>
                                {item.icon && (
                                    <Icon
                                        type={item.icon}
                                        theme="filled"
                                        style={{ fontSize: '16px', color: '#fe6100', marginRight: '5px' }}
                                    />
                                )}
                                {item.title}
                            </>
                        }
                    />
                    {item.image && (
                        <img
                            src={item.image}
                            alt={item.title}
                            style={{ width: '160px', height: 'auto', marginTop: '4px' }}
                        />
                    )}
                    {item.legal ? (
                        <div style={{ marginTop: '8px', fontSize: '11px', lineHeight: 1.5, color: '#8c8c8c' }}>
                            {item.legal}
                        </div>
                    ) : (
                        item.content
                    )}
                </List.Item>
            )}
        />
    );
}
